export default {
    top: {
        "首页": "首页",
        "公司产品": "公司产品",
        "公司团队": "公司团队",
        "全球合作伙伴": "全球合作伙伴",
        "联系我们": "联系我们",
        "请输入关键字": "请输入关键字",
        "了解更多": "了解更多",
        "快速开始": "快速开始",
        "热爱&专业&坚持": "热爱&专业&坚持",
        "南京禄高运动器材有限公司": "南京禄高运动器材有限公司",
    },
    introduce: {
        "关于南京禄高运动器材有限公司": "关于南京禄高运动器材有限公司",
        "南京禄高运动器材有限公司成立于2015年": "南京禄高运动器材有限公司成立于2015年",
        "总部位于江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室": "总部位于江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室",
        "是一家在国际体育用品贸易领域具有显著影响力的专业企业": "是一家在国际体育用品贸易领域具有显著影响力的专业企业",
        "公司专注于足、篮、排及其它充气球类产品的贸易往来": "公司专注于足、篮、排及其它充气球类产品的贸易往来",
        "依托旗下具备强大实力的生产工厂": "依托旗下具备强大实力的生产工厂",
        "构建了集研发、生产、销售为一体的完整产业链服务体系": "构建了集研发、生产、销售为一体的完整产业链服务体系",
        "致力于为全球客户提供一站式的球类产品解决方案": "致力于为全球客户提供一站式的球类产品解决方案",
        "强 大": "强 大",
        "工厂依托": "工厂依托",
        "强大的工厂依托": "强大的工厂依托",
        "旗下工厂常州禄旺运动器材有限公司拥有先进的生产设施与专业的技术团队。": "旗下工厂常州禄旺运动器材有限公司拥有先进的生产设施与专业的技术团队。",
        "旗下工厂拥有先进的生产设施与专业的技术团队。工厂内配备一系列自动化生产设备，从原材料进厂到成品的组装，每一个生产环节都实现了高效、精准的运作，确保产品的稳定供应。同时，工厂高度重视产品质量，建立了严格的质量管理体系，每一件产品都经过层层筛选，以卓越的品质符合甚至超越国际质量标准，为贸易业务提供了坚实可靠的产品保障。": "旗下工厂拥有先进的生产设施与专业的技术团队。工厂内配备一系列自动化生产设备，从原材料进厂到成品的组装，每一个生产环节都实现了高效、精准的运作，确保产品的稳定供应。同时，工厂高度重视产品质量，建立了严格的质量管理体系，每一件产品都经过层层筛选，以卓越的品质符合甚至超越国际质量标准，为贸易业务提供了坚实可靠的产品保障。",
        "卓 越": "卓 越",
        "研发能力": "研发能力",
        "卓越的研发能力": "卓越的研发能力",
        "依托工厂的专业研发团队，公司在球类产品的创新上表现卓越。": "依托工厂的专业研发团队，公司在球类产品的创新上表现卓越。",
        "依托工厂的专业研发团队，公司在球类产品的创新上表现卓越。研发人员凭借深厚的行业经验与对市场趋势的敏锐洞察，持续探索新材料、新工艺，不断推陈出新。目前已成功研发出多款具备独特性能与外观设计的球类产品，部分创新成果获得国家专利，使公司在激烈的市场竞争中脱颖而出，能够为客户提供更具竞争力、更符合市场需求的产品选择。": "依托工厂的专业研发团队，公司在球类产品的创新上表现卓越。研发人员凭借深厚的行业经验与对市场趋势的敏锐洞察，持续探索新材料、新工艺，不断推陈出新。目前已成功研发出多款具备独特性能与外观设计的球类产品，部分创新成果获得国家专利，使公司在激烈的市场竞争中脱颖而出，能够为客户提供更具竞争力、更符合市场需求的产品选择。",
        "丰 富": "丰 富",
        "合作经验": "合作经验",
        "丰富的合作经验": "丰富的合作经验",
        "无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。": "无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。",
        "凭借出色的产品质量与服务能力，公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系。在代工过程中，严格遵循品牌方的各项要求，从产品设计理念的贯彻到生产工艺的精准执行，都力求完美，确保每一款代工产品都能充分展现品牌方的特色与品质标准。丰富的代工经验使公司能够灵活应对各种复杂的订单需求，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。": "凭借出色的产品质量与服务能力，公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系。在代工过程中，严格遵循品牌方的各项要求，从产品设计理念的贯彻到生产工艺的精准执行，都力求完美，确保每一款代工产品都能充分展现品牌方的特色与品质标准。丰富的代工经验使公司能够灵活应对各种复杂的订单需求，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。",
    },
    product: {
        "我们专注体育用品贸易，提供贴皮及机缝工艺的足球、篮球、排球、橄榄球。": "我们专注体育用品贸易，提供贴皮及机缝工艺的足球、篮球、排球、橄榄球。",
        "了解更多": "了解更多",
        "info": "在资质认证方面，工厂已取得多项权威合规证书与国际认证许可，涵盖 ISO 9001 、ISO 14001 、ISO 45001、BSCI、SCSA、SLCP等等认证。并同时拥有FIFA、FIBA、FIVB三大球认证生产资质。同时，产品通过 SGS、Intertek等第三方机构严格检测，确保产品在全球市场畅行无阻。",
    },
    team: {
        "公司拥有一支专业且经验丰富的外贸团队，熟悉国际贸易流程与规则，具备成熟完善的进出口能力。": "公司拥有一支专业且经验丰富的外贸团队，熟悉国际贸易流程与规则，具备成熟完善的进出口能力。",
        "团队能够高效处理各类进出口业务，从合同签订、报关报检、物流运输到售后服务，为客户提供全方位、一站式的贸易服务。公司与全球多个国家和地区的客户建立了良好的贸易往来，产品畅销海外市场，深受国际客户的认可与好评。同时，积极引进国外先进的生产技术与管理经验，不断优化自身业务流程，提升综合实力，以更好地适应全球市场的变化与需求。": "团队能够高效处理各类进出口业务，从合同签订、报关报检、物流运输到售后服务，为客户提供全方位、一站式的贸易服务。公司与全球多个国家和地区的客户建立了良好的贸易往来，产品畅销海外市场，深受国际客户的认可与好评。同时，积极引进国外先进的生产技术与管理经验，不断优化自身业务流程，提升综合实力，以更好地适应全球市场的变化与需求。",
        "工厂汇聚行业内资深的专业人才，拥有经验丰富的研发设计团队、熟练精湛的生产技术骨干，以及严谨细致的质检人员。研发团队持续探索新型材料与工艺，已获得多项国家专利；生产技术人员凭借精湛技艺，保障产品高效稳定产出；质检团队严格把控每一道工序，确保产品零缺陷出厂。凭借严格的品控体系，从原料采购到成品出厂，每道工序均设置严格质检节点，确保零缺陷品控。": "工厂汇聚行业内资深的专业人才，拥有经验丰富的研发设计团队、熟练精湛的生产技术骨干，以及严谨细致的质检人员。研发团队持续探索新型材料与工艺，已获得多项国家专利；生产技术人员凭借精湛技艺，保障产品高效稳定产出；质检团队严格把控每一道工序，确保产品零缺陷出厂。凭借严格的品控体系，从原料采购到成品出厂，每道工序均设置严格质检节点，确保零缺陷品控。",
    },
    friend: {
        "凭借出色的产品质量与服务能力，公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系。": "凭借出色的产品质量与服务能力，公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系。",
        "在代工过程中，严格遵循品牌方的各项要求，从产品设计理念的贯彻到生产工艺的精准执行，都力求完美，": "在代工过程中，严格遵循品牌方的各项要求，从产品设计理念的贯彻到生产工艺的精准执行，都力求完美，",
        "确保每一款代工产品都能充分展现品牌方的特色与品质标准。": "确保每一款代工产品都能充分展现品牌方的特色与品质标准。",
        "丰富的代工经验使公司能够灵活应对各种复杂的订单需求，无论是产品的定制化设计，": "丰富的代工经验使公司能够灵活应对各种复杂的订单需求，无论是产品的定制化设计，",
        "还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。": "还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。",
        "公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。": "公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。"
    },
    connect: {
        '预约': '预约',
        "合作咨询、咨询留言": "合作咨询、咨询留言",
        "填写下方信息，我们的团队将尽快与您联系，感谢您的信任!": "填写下方信息，我们的团队将尽快与您联系，感谢您的信任!",
        "公司/品牌名称*": "公司/品牌名称*",
        "邮箱*": "邮箱*",
        "联系电话*": "联系电话*",
        "需求建议*": "需求建议*",
        "提交信息": "提交信息",
        "南京禄高运动器材有限公司": "南京禄高运动器材有限公司",
        "江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室": "江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室",
        "联系人：": "联系人：",
        "杨经理：15312017202": "杨经理：15312017202",
        "吴经理：18362063562": "吴经理：18362063562",
        "邮箱1": "邮箱：brook{'@'}lg-sport.com",
        "邮箱2": "邮箱：kay{'@'}lg-sport.com",
        "合作咨询、咨询留言。填写以下信息，我们的团队将尽快与您联系。感谢您的信任！": "合作咨询、咨询留言。填写以下信息，我们的团队将尽快与您联系。感谢您的信任！",
    },
    footer: {
        "江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室": '江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室'
    },
    detail: {
        "产品名称：": "产品名称：",
        "工艺：": "工艺：",
        "贴皮": "贴皮",
        "材质：": "材质：",
        "简介：": "简介：",
        "产品图片：": "产品图片：",
        "关闭": "关闭"
    },
    message: {
        "文本复制成功": "文本复制成功",
        "没有更多产品了": "没有更多产品了",
        "请输入正确的邮箱格式": "请输入正确的邮箱格式",
        "请输入正确的联系电话": "请输入正确的联系电话",
        "数据获取失败": "数据获取失败",
        "暂无该类型产品": "暂无该类型产品",
        "暂无数据": "暂无数据",
        "请输入公司姓名": "请输入公司姓名",
        "请输入您的建议": "请输入您的建议",
        "操作成功": "操作成功"
    },
    brand: {
        "前往官网": "前往官网",
    },
    world: {
        "世界数据地图": "世界数据地图",
        "展示全球各国数据分布情况": "展示全球各国数据分布情况",
        "数据来源：系统统计": "数据来源：系统统计",
        "销量": "销量",
        "高": "高",
        "低": "低",
        "世界地图": "世界地图",
    },
    index: {
        "首页": "首页",
        "产品": "产品",
        "解决方案": "解决方案",
        "联系我们": "联系我们",
        "搜索产品": "搜索产品...",
        "了解更多": "了解更多",
        "南京禄高运动器材有限公司": "南京禄高运动器材有限公司",
        "查看更多": "查看更多",
        "常州禄旺运动器材有限公司": "常州禄旺运动器材有限公司",
        "禄高全资子公司": "(禄高全资子公司)",
        "占地面积(㎡)": "占地面积(㎡)",
        "年产能": "年产能",
        "员工人数": "员工人数",
        "销售地区": "销售地区",
        "热销产品": "热销产品",
        "选择我们的优势": "选择我们的优势",
        "真诚服务 客服至上": "真诚服务 客服至上",
        "现代化工厂": "现代化工厂",
        "研发能力卓越": "研发能力卓越",
        "合作经验丰富": "合作经验丰富",
        "一站式服务": "一站式服务",
        "专业OEM/ODM流程": "专业OEM/ODM流程",
        "服务全球品牌": "服务全球品牌",
        "全球合作伙伴": "全球合作伙伴",
        "资质认证": "资质认证",
        "权威认证 · 品质保障": "权威认证 · 品质保障",
        "曾言咨询·商光治波": "曾言咨询·商光治波",
        "合作咨询、咨询留言": "合作咨询、咨询留言",
        "备案号:": "备案号:",
        "产品中心": "产品中心",
        "查看全部": "查看全部",
        "上一张": "上一张",
        "下一张": "下一张",
        "灵活MOQ起订量": "灵活MOQ起订量",
        "适配多元合作需求": "适配多元合作需求",
    }
}
